// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.basic-layout[data-v-d4ba89ee] {\n  position: relative;\n  min-height: 100vh;\n  background: var(--portal-bg);\n  color: var(--portal-text);\n}\n.basic-layout__toolbar[data-v-d4ba89ee] {\n  position: absolute;\n  top: 1.25rem;\n  right: 1.25rem;\n  z-index: 10;\n}\n", ""]);
// Exports
module.exports = exports;
